import { FC } from 'react';

import Link from 'bloko/blocks/link';

export const User: FC<{ userId: number; userName: string }> = ({ userId, userName }) => (
    <>
        {userName} (
        <Link href={`/new/admin/users/${userId}/`} target="_blank">
            {userId}
        </Link>
        )
    </>
);
